import {
  IconBuildings,
  BorderRadius6,
  CustomerCard,
  GreyGrey30,
  GreyWhite,
  Box
} from '@sequencehq/core-components'
import { ErrorBoundary } from 'common/components/ErrorBoundary/ErrorBoundary'
import { NodeTimeline } from 'Automations/components'
import { getLogoSrc } from 'Customer/index'
import { getPrimaryBillingContact } from 'CustomerContacts/index'
import { ExtractedCustomer } from './types'

export const ExtractedCustomerDataTimelineItem = ({
  customer,
  timestamp,
  showPreview = true
}: {
  customer: ExtractedCustomer
  timestamp?: string
  showPreview?: boolean
}) => {
  return (
    <NodeTimeline.Item icon={<IconBuildings />} showStem>
      <NodeTimeline.Title>
        <NodeTimeline.UserAction
          label="Customer information extracted"
          timestamp={timestamp}
        />
      </NodeTimeline.Title>
      {showPreview && (
        <ErrorBoundary name="ExtractedCustomerDataTimelineItem">
          <ContractCustomerPreview customer={customer} />
        </ErrorBoundary>
      )}
    </NodeTimeline.Item>
  )
}

const ContractCustomerPreview = ({
  customer
}: {
  customer: ExtractedCustomer
}) => {
  const logoSrc = getLogoSrc(customer)

  return (
    <Box
      padding="12px 16px"
      width="fit-content"
      minWidth="314px"
      maxWidth="100%"
      backgroundColor={GreyWhite}
      border={`1px solid ${GreyGrey30}`}
      borderRadius={BorderRadius6}
    >
      <CustomerCard
        legalName={customer.legalName ?? 'Unknown Customer'}
        customerId={customer.id ?? 'new-customer'}
        address={customer.address ?? undefined}
        billingEmail={getPrimaryBillingContact(customer.contacts ?? [])?.email}
        logoSrc={logoSrc}
      />
    </Box>
  )
}
